import { schemas } from '@repo/contracts'
import { apiErrorHandler } from '../errorHandler'
import { parseDataOfType } from '../../common/parseDataType'
import { optionalProjectId } from '../../common/optionalFields'
import type { z } from 'zod'

// -- Wire types (generated; @repo/contracts is the source of truth) --

export type RagText = z.infer<typeof schemas.apihttp_RagTextItemV2>
export type GetRagTextResponse = z.infer<typeof schemas.apihttp_SearchTextV2Response>
export type FetchRagTexts = z.input<typeof schemas.apihttp_SearchRequestV2>

const defaultFetchParams: FetchRagTexts = {
  currentPage: 1
}

export async function fetchRagTexts(params: Partial<FetchRagTexts> = {}): Promise<GetRagTextResponse> {
  const body: FetchRagTexts = { ...defaultFetchParams, ...params }
  const res = await fetch('/api/content/text/searchv2', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(body)
  })
  await apiErrorHandler(res)
  const data: unknown = await res.json()
  return parseDataOfType(data, schemas.apihttp_SearchTextV2Response)
}

export async function createRagText(text: string, projectId?: number, tagIds: Array<number> = []): Promise<void> {
  const res = await fetch('/api/content/text', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(schemas.apihttp_AddRagTextRequest.parse({ text, tagIds, ...optionalProjectId(projectId) }))
  })
  await apiErrorHandler(res)
}

export async function updateRagText(
  docId: number,
  text: string,
  projectId: number | undefined,
  tagIds: Array<number>
): Promise<void> {
  const res = await fetch(`/api/content/text/${docId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(schemas.apihttp_UpdateRagTextRequest.parse({ text, tagIds, ...optionalProjectId(projectId) }))
  })
  await apiErrorHandler(res)
}

export async function deleteRagText(docId: number, projectId?: number): Promise<void> {
  const url =
    projectId !== undefined ? `/api/content/text/${docId}?projectId=${projectId}` : `/api/content/text/${docId}`
  const res = await fetch(url, {
    method: 'DELETE',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}
